import { gateNames } from '@mp/constants';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { useCurrentUser, useGate } from '@mp/hooks';
import { JobDetailsFragment } from '../jobDetailsComponents/graphql';

export const useShiftSwapData = ({
  job: inputJob,
}: {
  job?: FragmentType<typeof JobDetailsFragment> | null;
}) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  const { currentUser, isSaas } = useCurrentUser();
  const isShiftSwapEnabled = useGate(gateNames.direct_shift_release_pro);

  const requesteeId = job?.pending_shift_request?.requestee_account_info?.professional_id;

  const proIsRequestee = requesteeId === currentUser?.professional?.id;

  const proIsRequester =
    job?.pending_shift_request?.requester_account_info?.professional_id ===
    currentUser?.professional?.id;

  const requestStatus = job?.pending_shift_request?.status;

  const requestType = job?.pending_shift_request?.request_kind;

  const canShowShiftReleaseInfo = isShiftSwapEnabled && isSaas;

  const requestIsSwap = requestType === 'swap';
  const requestIsRelease = requestType === 'release';
  const requestIsDrop = requestType === 'drop';

  const proHasSwapRequestToAcceptOrDecline =
    canShowShiftReleaseInfo &&
    proIsRequestee &&
    requestStatus === 'pending_requestee' &&
    requestIsSwap;

  const proHasSwapRequestPendingFacility =
    canShowShiftReleaseInfo && proIsRequestee && requestStatus === 'pending' && requestIsSwap;

  const proDidSwapRequest =
    canShowShiftReleaseInfo &&
    proIsRequester &&
    (requestStatus === 'pending_requestee' || requestStatus === 'pending') &&
    requestIsSwap;

  const proAwaitingReleaseRequest =
    canShowShiftReleaseInfo && proIsRequester && requestStatus === 'pending' && requestIsRelease;

  const proAwaitingDropRequest =
    canShowShiftReleaseInfo && proIsRequester && requestStatus === 'pending' && requestIsDrop;

  const requestRejected = canShowShiftReleaseInfo && proIsRequester && requestStatus === 'declined';

  const swapBannerName = `${job?.pending_shift_request?.requester_account_info?.name || ''}`;

  return {
    proHasSwapRequestToAcceptOrDecline,
    proHasSwapRequestPendingFacility,
    proDidSwapRequest,
    proAwaitingReleaseRequest,
    proAwaitingDropRequest,
    requestRejected,
    swapBannerName,
    requestIsDrop,
    canShowShiftReleaseInfo,
    requesteeId,
    proIsRequestee,
    awaitingShiftRequestHours: job?.location?.release_approval_window_hours,
  };
};
